/* =====================================================================
 * CUSTOM:AQARA-HK  Pre-settle the product layout on load
 * ---------------------------------------------------------------------
 * The theme finalises a variant-dependent block (the English-name / SKU
 * row above the price) only the first time a variant-change event fires,
 * which makes the product column — and therefore the footer — grow ~40px
 * the FIRST time the shopper changes colour (this happens from the main
 * swatch too, not just the sticky bar). We fire that finalisation ONCE at
 * load on the ALREADY-selected option (same value, so no real variant
 * change), so the layout settles to its final height before any
 * interaction and never shifts afterwards. Guarded + self-contained,
 * silently no-ops when the target markup is absent.
 * ===================================================================== */
(function () {
  'use strict';

  function optionsRoot() {
    return document.querySelector('product-options-element[data-main-product="true"]')
        || document.querySelector('product-options-element.product-options--root')
        || document.querySelector('.product-options--root');
  }

  function fire() {
    var root = optionsRoot();
    var checked = root && root.querySelector('input.swatch--input:checked, input[type="radio"]:checked');
    if (!checked) return;
    /* Re-dispatch change on the CURRENT selection (no variant change) so the
       theme renders the variant-dependent layout to its final height now. */
    checked.dispatchEvent(new Event('input', { bubbles: true }));
    checked.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function run() {
    if (!optionsRoot()) return;
    /* The theme's variant components (theme.js is a module) initialise AFTER
       DOMContentLoaded, so a single early dispatch has no handler to react to.
       Retry every 250ms until the layout actually settles (document height
       changes) — i.e. until the theme has processed our synthetic change —
       then stop. Capped so we never loop forever. */
    var startH = document.documentElement.scrollHeight;
    var attempts = 0;
    (function attempt() {
      attempts++;
      fire();
      if (document.documentElement.scrollHeight !== startH || attempts >= 20) return;
      window.setTimeout(attempt, 250);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
